// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Ss-z","giftOrPromoSelector":"Ts-z","disabled":"Us-z","subTitle":"Vs-z","selectShipAddressMessage":"Ws-z","changePayment":"Xs-z"};